import { MutableRefObject } from 'react';
import { jsPDF } from 'jspdf';

export const downloadBlob = (blob: Blob, desiredName: string) => {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    link.download = `${desiredName}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
};

export const downloadCmpAsPdf = async (reference: MutableRefObject<any>, name: string): Promise<void> => {
    const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
    });

    await pdf.html(reference.current, {
        callback: function (doc) {
            doc.save(name + '.pdf');
        },
        margin: [10, 10, 10, 10],
        autoPaging: 'text',
        html2canvas: {
            scale: 0.215,
            useCORS: true,
            letterRendering: true
        }
    });
};
